// rm-list-item.js — single row in <rm-list>.
//
// Mirrors `Assets/_App/UI/Components/ListItemCell.cs`. Title + subtitle +
// completion bubble. STUB — current <rm-list> uses inline `<a>` tags; this
// element will replace them in a follow-up brief.

import { RMComponent } from "../core/component.js";
import { html } from "../core/html.js";

export class RMListItem extends RMComponent {
  static props = ["itemTitle", "subtitle", "href"];
  /** @type {string | null} */ itemTitle = null;
  /** @type {string | null} */ subtitle = null;
  /** @type {string | null} */ href = null;

  static styles = `
    :host { display: block; }
    a { display: block; padding: 0.75rem; border-radius: 0.5rem; text-decoration: none; color: var(--rm-fg); background: var(--rm-surface); }
    a:hover { background: var(--rm-surface-hover); }
    .sub { color: var(--rm-muted); font-size: 0.8rem; margin-top: 0.125rem; }
  `;

  render() {
    return html`
      <a href="${this.href ?? '#'}">
        ${this.itemTitle ?? ""}
        <div class="sub">${this.subtitle ?? ""}</div>
      </a>
    `;
  }
}
